import {
  FeedItemDto,
  UserMemberStatusDto,
} from '@act/shared/data-transfer-objects';
import { FilterChoices } from '@act/storybook';
import { EntityState } from '@reduxjs/toolkit';
import { LoadingStatus } from './sharedTypes';

export type EntityType = 'call' | 'message' | 'note' | 'visit' | 'appointment';

export const feedFilterChoices: FilterChoices<FeedFilter> = [
  {
    label: 'Calls',
    value: 'call',
  },
  {
    label: 'Messages',
    value: 'message',
  },
  {
    label: 'Visits',
    value: 'visit',
  },
  {
    label: 'Notes',
    value: 'note',
  },
  {
    label: 'Tasks',
    value: 'task',
  },
  {
    label: 'Hospital Events',
    value: 'hospital events',
  },
  {
    label: 'BH Appointments',
    value: 'appointment',
  },
];

export const feedFilterStrings = [
  'call',
  'message',
  'visit',
  'note',
  'task',
  'hospital events',
  'appointment',
] as const;

export type FeedFilter = (typeof feedFilterStrings)[number];
export const feedFiltersToEndpointFilters = (feedFilters: FeedFilter[]) => {
  const newFilters: string[] = [...feedFilters];

  if (feedFilters.includes('hospital events')) {
    const hospitalEventsIndex = newFilters.indexOf('hospital events');
    newFilters.push('hospitalization');
    newFilters.splice(hospitalEventsIndex, 1);
  }

  // Handle 'task' filter by expanding it to its component types
  if (feedFilters.includes('task')) {
    const taskIndex = newFilters.indexOf('task');
    newFilters.splice(taskIndex, 1); // Remove 'task'
    newFilters.push(
      'member_status_change_request',
      'member_transfer_request',
      'assigned_workflow_phase'
    );
  }

  return newFilters;
};

export type FeedEntry = EntityState<FeedItemDto, number>;
export type UserMemberStatusesEntry = EntityState<UserMemberStatusDto, number>;

export interface FeedState {
  status: LoadingStatus;
  selectedMemberId: string; // Used for deduplication during loading
  displayedMemberId: string | null; // Used for websocket event filtering
  selectedFeedFilters: FeedFilter[];
  feedItems: FeedEntry;
  userMemberStatuses: UserMemberStatusesEntry;
  lastLoadedPendingItemsMemberId: string | null;
  /** Tracks `getPendingItems` so UI can distinguish loading from an empty result. */
  pendingItemsFetchStatus: LoadingStatus;
}
